import { FONT_BASE, LINE_HEIGHT_BASE } from '../themeConstants'

export const muiComponentsBaseline = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        color: 'var(--app-text-primary)',
        backgroundColor: 'var(--app-bg-hover)',
        fontFamily: 'var(--app-font-sans)',
        fontSize: FONT_BASE,
        lineHeight: LINE_HEIGHT_BASE, letterSpacing: 0,
      },
    },
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontFamily: 'inherit',
        fontSize: FONT_BASE,
        lineHeight: LINE_HEIGHT_BASE, letterSpacing: 0,
      },
    },
  },
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        subtitle1: 'p',
        subtitle2: 'p',
        body1: 'p',
        body2: 'p',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
        cornerShape: 'var(--app-corner-shape)', WebkitCornerSmoothing: 'var(--app-squircle-ratio)',
      },
    },
  },
}
